import styled from 'styled-components';
import AppCSS from '../../../../../utils/styled';

const ROW_HEIGHT = 32;
const LIST_HEIGHT = 3 * ROW_HEIGHT;

export const Components = {
  Container: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
  `,

  ListAndButtonsWrapper: styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    width: 100%;
  `,

  ListContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.radiuses.small};
    height: ${LIST_HEIGHT}px;
    max-height: ${LIST_HEIGHT}px;
    overflow-x: hidden;
    overflow-y: auto;
  `,

  ListEntry: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: ${ROW_HEIGHT}px;
    min-height: ${ROW_HEIGHT}px;
    gap: 4px;
    &:hover {
      background-color: ${AppCSS.colors.greys.light};
    }
  `,

  ListEntryText: styled.div`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  CheckIconWrapper: styled.div`
    min-width: 16px;
  `,

  FooterContainer: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  `,

  ButtonsContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    min-width: 140px;
    padding-top: 12px;
  `,

  AddButton: styled(AppCSS.buttonStyles.SecondaryButtonStyle)`
    min-width: 140px;
  `,

  EditButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
  DeleteButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)`
    color: ${AppCSS.colors.red};
  `,
};
